import { SelectedPanelEnum } from '@app/core/enums/selected-panel.enum';
import { ProductPanelInterface } from '@app/core/interfaces';
import * as fromCalculation from '@app/store/my-zone/calculation/calculation.actions';
import * as fromProduct from '@app/store/my-zone/product/product.actions';
import * as fromProductPanel from './product-panel.actions';

export interface State {
    selectedId: number;
    selectedPanel: SelectedPanelEnum;
}

export const initialProductsState: State = {
    selectedId: null,
    selectedPanel: null,
};

export function reducer(
    state: State = initialProductsState,
    action: fromProductPanel.ProductPanelActions | fromProduct.ProductsActions | fromCalculation.CalculationsActions,
    ): State {

    switch (action.type) {

        case fromProductPanel.SELECT: {
            return {
                ...state,
                ...action.payload,
            };
        }

        case fromProduct.TERMINATE_ACTIVE_PURCHASED_PRODUCT_SUCCESS:
        case fromProduct.STORE_NON_REGULAR_DRIVER_SUCCESS:
        case fromProduct.CANCEL_FUTURE_NON_REGULAR_DRIVER_SUCCESS:
        case fromProduct.TERMINATE_ACTIVE_NON_REGULAR_DRIVER_SUCCESS:
        case fromProduct.MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE_SUCCESS:
        case fromProduct.MODIFY_TERMINATION_DATE_FOR_PRODUCT_END_DATE_SUCCESS:
        case fromCalculation.CHANGE_GENERIC_PURCHASED_COVERAGES_SUCCESS:
        case fromCalculation.CANCEL_FUTURE_PURCHASED_COVERAGE_SUCCESS: {
            const { selectedPanel, selectedId } = state;
            const productPanel: ProductPanelInterface = {
                selectedPanel, selectedId,
            };

            if (selectedPanel !== SelectedPanelEnum.InsuranceDetail) {
                productPanel.selectedPanel = null;
                productPanel.selectedId = null;
            }

            return {
                ...state,
                ...productPanel,
            };
        }

        case fromProductPanel.RESET: {
            return initialProductsState;
        }

        default: {
            return state;
        }
    }
}

export const getSelectedId = (state: State) => state.selectedId;
export const getSelectedPanel = (state: State) => state.selectedPanel;
